import React, { useState, useEffect, useContext, useRef } from 'react';
import { AuthContext } from '../context/AuthContext';
import { apiGet, apiPut, apiDelete, apiPost } from '../services/api';
import { fmtDate as _fmtDateUTC, parseUTC as _parseUTC } from '../services/dates';
import './AjustesPage.css';

// ── IcoUser (para tab Mi perfil) ──────────────────────────────────────────────
const IcoUser = ({ size = 16 }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width={size} height={size}>
    <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
  </svg>
);
const IcoShop = ({ size = 16 }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width={size} height={size}>
    <path d="M3 9l1-4h16l1 4"/><rect x="2" y="9" width="20" height="12" rx="2"/><line x1="12" y1="9" x2="12" y2="21"/>
  </svg>
);

// ── Helpers ───────────────────────────────────────────────────────────────────

const PREVIEW_LEAD = { name: 'María García', phone: '612345678', city: 'Madrid' };

function applyVars(tpl, lead) {
  const today = new Date().toLocaleDateString('es-ES', { day:'2-digit', month:'2-digit', year:'numeric' });
  return (tpl || '')
    .replace(/\{\{nombre\}\}/gi,    lead.name  || '')
    .replace(/\{\{Telefono\}\}/gi,  lead.phone || '')
    .replace(/\{\{poblacion\}\}/gi, lead.city  || '')
    .replace(/\{\{fecha\}\}/gi,     today);
}

function initials(name) {
  return (name || '?').split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase();
}

const VARS = [
  { v: '{{nombre}}',    desc: 'Nombre'   },
  { v: '{{Telefono}}',  desc: 'Teléfono' },
  { v: '{{poblacion}}', desc: 'Ciudad'   },
  { v: '{{fecha}}',     desc: 'Fecha'    },
];

// ── Icons ─────────────────────────────────────────────────────────────────────

const IcoFacebook = ({ size = 16 }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width={size} height={size}>
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const IcoWA = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="15" height="15">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const IcoEmail = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="15" height="15">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);

const IcoBuilding = ({ size = 16 }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width={size} height={size}>
    <rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 3v18M15 3v18M3 9h6M3 15h6M15 9h6M15 15h6"/>
  </svg>
);

const IcoChat = ({ size = 16 }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width={size} height={size}>
    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
  </svg>
);

const IcoCalc = ({ size = 16 }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width={size} height={size}>
    <rect x="4" y="2" width="16" height="20" rx="2"/><line x1="8" y1="6" x2="16" y2="6"/><line x1="8" y1="10" x2="16" y2="10"/><line x1="8" y1="14" x2="12" y2="14"/>
  </svg>
);

const IcoDoc = ({ size = 16 }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width={size} height={size}>
    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
  </svg>
);

const IcoReparto = ({ size = 16 }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width={size} height={size}>
    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/>
  </svg>
);

// ── EmpresaTab ────────────────────────────────────────────────────────────────

function EmpresaTab() {
  const { auth, setAuth } = useContext(AuthContext);
  const token   = auth.token;
  const isAdmin = ['admin', 'superadmin'].includes(auth.user?.role);

  const [logo,    setLogo]    = useState('');
  const [colors,  setColors]  = useState({ brand: '#E84300', brandLight: '#FFF0EB', pageBg: '#ddd4d0' });
  const [company, setCompany] = useState({ nombre: '', nif: '', direccion: '', cp: '', ciudad: '', telefono: '', email: '', web: '' });
  const [loading, setLoading] = useState(true);
  const [saving,  setSaving]  = useState(false);
  const [saved,   setSaved]   = useState(false);

  useEffect(() => {
    apiGet('/settings', token)
      .then(d => {
        if (d.logo) setLogo(d.logo);
        if (d.colors && Object.keys(d.colors).length) setColors(c => ({ ...c, ...d.colors }));
        if (d.company_data && Object.keys(d.company_data).length) setCompany(d.company_data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [token]);

  function handleLogoFile(e) {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 500 * 1024) { alert('El archivo es demasiado grande. Usa una imagen de menos de 500 KB.'); return; }
    const reader = new FileReader();
    reader.onload = evt => setLogo(evt.target.result);
    reader.readAsDataURL(file);
  }

  async function save() {
    setSaving(true);
    try {
      // Fusionar con company_data del servidor para preservar campos editados en otras pestañas
      // (p.ej. quote_footer del Pie de presupuesto). Sin esto, guardar Conf. empresa
      // sobrescribiría todo company_data con solo los campos locales y borraría el pie.
      let mergedCompany = company;
      try {
        const fresh = await apiGet('/settings', token);
        mergedCompany = { ...(fresh.company_data || {}), ...company };
      } catch (_) { /* si falla el fetch, al menos no peor que antes */ }

      await apiPut('/settings', { logo: logo || null, colors, company_data: mergedCompany }, token);
      // Update auth context so logo/colors apply live
      setAuth(prev => ({
        ...prev,
        tenant: { ...(prev.tenant || {}), logo: logo || null, colors, company_data: mergedCompany },
      }));
      // Apply colors immediately to CSS vars
      const root = document.documentElement;
      if (colors.brand) {
        root.style.setProperty('--brand',      colors.brand);
        const n = parseInt(colors.brand.replace('#',''), 16);
        const rd = Math.min(255,Math.max(0,(n>>16)-20));
        const gd = Math.min(255,Math.max(0,((n>>8)&0xff)-20));
        const bd = Math.min(255,Math.max(0,(n&0xff)-20));
        root.style.setProperty('--brand-dark', '#'+[rd,gd,bd].map(x=>x.toString(16).padStart(2,'0')).join(''));
      }
      if (colors.brandLight) root.style.setProperty('--brand-light', colors.brandLight);
      if (colors.pageBg)     root.style.setProperty('--page-bg',     colors.pageBg);
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (e) {
      alert(e.message);
    } finally {
      setSaving(false);
    }
  }

  const set = (k, v) => setCompany(p => ({ ...p, [k]: v }));

  if (loading) return <div className="aj-loading">Cargando configuración…</div>;

  return (
    <div className="aj-empresa">

      {/* Logo */}
      <div className="aj-card">
        <h3 className="aj-card-title">Logotipo</h3>
        <div className="aj-logo-row">
          <div className="aj-logo-preview">
            {logo
              ? <img src={logo} alt="Logo" />
              : <span className="aj-logo-initials">{initials(auth.tenant?.name || 'E')}</span>
            }
          </div>
          <div className="aj-logo-actions">
            <p className="aj-logo-hint">Sube el logo de tu empresa. Aparecerá en el menú lateral y en los documentos generados.</p>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <label className="aj-upload-btn">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12"/>
                </svg>
                Subir imagen
                <input type="file" accept="image/*" style={{ display: 'none' }} onChange={handleLogoFile} disabled={!isAdmin} />
              </label>
              {logo && isAdmin && (
                <button className="aj-logo-del" onClick={() => setLogo('')}>Eliminar</button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Colores */}
      <div className="aj-card">
        <h3 className="aj-card-title">Colores del CRM</h3>
        <p className="aj-empresa-hint">Personaliza los colores de la interfaz. Los cambios se aplican en tiempo real al guardar.</p>
        <div className="aj-color-list">
          {[
            { key: 'brand',      label: 'Color principal',          desc: 'Botones, enlaces activos y acentos',     fallback: '#E84300' },
            { key: 'brandLight', label: 'Color de fondo claro',     desc: 'Fondo suave de etiquetas y badges',      fallback: '#FFF0EB' },
            { key: 'pageBg',     label: 'Fondo del área principal', desc: 'Color de fondo de la zona de contenido', fallback: '#ddd4d0' },
          ].map(c => (
            <div key={c.key} className="aj-color-row">
              <div className="aj-color-info">
                <span className="aj-color-label">{c.label}</span>
                <span className="aj-color-desc">{c.desc}</span>
              </div>
              <div className="aj-color-pick">
                <input
                  type="color"
                  value={colors[c.key] || c.fallback}
                  onChange={e => setColors(p => ({ ...p, [c.key]: e.target.value }))}
                  disabled={!isAdmin}
                  className="aj-color-input"
                />
                <code className="aj-color-hex">{colors[c.key] || c.fallback}</code>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Datos empresa */}
      <div className="aj-card">
        <h3 className="aj-card-title">Datos de la empresa</h3>
        <p className="aj-empresa-hint">Estos datos aparecerán en tus presupuestos y facturas.</p>
        <div className="aj-empresa-grid">
          {[
            { key: 'nombre',    label: 'Nombre de la empresa', placeholder: 'Mi empresa S.L.',            full: false },
            { key: 'nif',       label: 'NIF / CIF',            placeholder: 'B12345678',                  full: false },
            { key: 'direccion', label: 'Dirección',            placeholder: 'Calle Mayor 1',              full: true  },
            { key: 'cp',        label: 'Código postal',        placeholder: '46000',                      full: false },
            { key: 'ciudad',    label: 'Ciudad',               placeholder: 'Valencia',                   full: false },
            { key: 'telefono',  label: 'Teléfono',             placeholder: '+34 600 000 000',            full: false },
            { key: 'email',     label: 'Email de contacto',    placeholder: 'info@miempresa.com',         full: false },
            { key: 'web',       label: 'Página web',           placeholder: 'https://miempresa.com',      full: true  },
          ].map(f => (
            <div key={f.key} className={`aj-field ${f.full ? 'aj-field--full' : ''}`}>
              <label className="aj-label">{f.label}</label>
              <input
                className="aj-input"
                value={company[f.key] || ''}
                onChange={e => set(f.key, e.target.value)}
                placeholder={f.placeholder}
                disabled={!isAdmin}
              />
            </div>
          ))}
        </div>
      </div>

      {isAdmin ? (
        <div className="aj-footer">
          <button className={`aj-save ${saved ? 'aj-save--ok' : ''}`} onClick={save} disabled={saving}>
            {saved ? '✓ Guardado' : saving ? 'Guardando…' : 'Guardar cambios'}
          </button>
        </div>
      ) : (
        <p className="aj-no-perm">Solo los administradores pueden editar esta configuración.</p>
      )}
    </div>
  );
}

// ── MensajesTab ───────────────────────────────────────────────────────────────

// userMode=true → carga/guarda plantillas personales del usuario (comercial)
// userMode=false → carga/guarda plantillas del tenant (admin)
function MensajesTab({ token, isAdmin, userMode = false }) {
  const canEdit = userMode || isAdmin;
  const [tpl,     setTpl]     = useState({ whatsapp_no_quote:'', whatsapp_quote:'', email_subject:'', email_body:'' });
  const [loading, setLoading] = useState(true);
  const [saving,  setSaving]  = useState(false);
  const [saved,   setSaved]   = useState(false);
  const [focused, setFocused] = useState(null);
  const [campaigns, setCampaigns] = useState([]);

  const fieldRefs = {
    whatsapp_no_quote: useRef(null),
    whatsapp_quote:    useRef(null),
    email_subject:     useRef(null),
    email_body:        useRef(null),
  };
  const cursor = useRef({ key: null, start: 0, end: 0 });

  function saveCursor(key) {
    const el = fieldRefs[key]?.current;
    if (!el) return;
    cursor.current = { key, start: el.selectionStart, end: el.selectionEnd };
    setFocused(key);
  }

  useEffect(() => {
    const url = userMode ? '/users/me/templates' : '/settings';
    apiGet(url, token)
      .then(d => setTpl(userMode ? d : (d.contact_templates || {})))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [token, userMode]); // eslint-disable-line react-hooks/exhaustive-deps

  const set = (k, v) => setTpl(p => ({ ...p, [k]: v }));

  // Campañas existentes (para el selector de plantillas por campaña) — solo config de tenant
  useEffect(() => {
    if (userMode) return;
    apiGet('/leads/campaigns', token)
      .then(d => setCampaigns(Array.isArray(d) ? d : []))
      .catch(() => {});
  }, [token, userMode]);

  function addCampaign() {
    setTpl(p => ({ ...p, whatsapp_campaigns: [ ...(p.whatsapp_campaigns || []), { campaign: '', whatsapp_no_quote: '', whatsapp_quote: '' } ] }));
  }
  function updateCampaign(idx, key, val) {
    setTpl(p => {
      const arr = [ ...(p.whatsapp_campaigns || []) ];
      arr[idx] = { ...arr[idx], [key]: val };
      return { ...p, whatsapp_campaigns: arr };
    });
  }
  function removeCampaign(idx) {
    setTpl(p => ({ ...p, whatsapp_campaigns: (p.whatsapp_campaigns || []).filter((_, i) => i !== idx) }));
  }

  function insertVar(variable) {
    const { key, start, end } = cursor.current;
    if (!key) return;
    const el   = fieldRefs[key]?.current;
    const prev = tpl[key] || '';
    const next = prev.slice(0, start) + variable + prev.slice(end);
    set(key, next);
    const newCursor = start + variable.length;
    cursor.current = { key, start: newCursor, end: newCursor };
    requestAnimationFrame(() => {
      el?.focus();
      el?.setSelectionRange(newCursor, newCursor);
    });
  }

  async function save() {
    setSaving(true);
    try {
      const url = userMode ? '/users/me/templates' : '/settings/contact-templates';
      await apiPut(url, tpl, token);
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (e) { alert(e.message); }
    finally { setSaving(false); }
  }

  if (loading) return <div className="aj-loading">Cargando…</div>;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      {/* Chips de variables */}
      <div className="aj-card">
        <div className="aj-vars-header">
          <span className="aj-vars-title">Variables</span>
          <span className="aj-vars-hint">
            {focused
              ? <>Haz clic para insertar en <strong>{focused.replace(/_/g, ' ')}</strong></>
              : 'Haz clic en un campo y luego en una variable para insertarla'}
          </span>
        </div>
        <div className="aj-vars">
          {VARS.map(v => (
            <button
              key={v.v}
              className={`aj-var-chip ${focused ? 'aj-var-chip--active' : ''}`}
              onClick={() => insertVar(v.v)}
              type="button"
            >
              <code>{v.v}</code>
              <span>{v.desc}</span>
            </button>
          ))}
        </div>
      </div>

      {/* WhatsApp sin presupuesto */}
      <div className="aj-card">
        <h3 className="aj-card-title"><span className="aj-icon aj-icon--wa"><IcoWA/></span>WhatsApp — Sin presupuesto</h3>
        <textarea
          ref={fieldRefs.whatsapp_no_quote}
          className={`aj-textarea ${focused==='whatsapp_no_quote' ? 'aj-textarea--focused' : ''}`}
          rows={4}
          value={tpl.whatsapp_no_quote || ''}
          onChange={e => set('whatsapp_no_quote', e.target.value)}
          onFocus={() => saveCursor('whatsapp_no_quote')}
          onKeyUp={() => saveCursor('whatsapp_no_quote')}
          onMouseUp={() => saveCursor('whatsapp_no_quote')}
          onSelect={() => saveCursor('whatsapp_no_quote')}
          disabled={!canEdit}
          placeholder="Mensaje para primer contacto…"
        />
        <div className="aj-preview">
          <span className="aj-preview-lbl">Vista previa:</span>
          <span className="aj-preview-txt">{applyVars(tpl.whatsapp_no_quote, PREVIEW_LEAD)}</span>
        </div>
      </div>

      {/* WhatsApp con presupuesto */}
      <div className="aj-card">
        <h3 className="aj-card-title"><span className="aj-icon aj-icon--wa"><IcoWA/></span>WhatsApp — Con presupuesto</h3>
        <textarea
          ref={fieldRefs.whatsapp_quote}
          className={`aj-textarea ${focused==='whatsapp_quote' ? 'aj-textarea--focused' : ''}`}
          rows={4}
          value={tpl.whatsapp_quote || ''}
          onChange={e => set('whatsapp_quote', e.target.value)}
          onFocus={() => saveCursor('whatsapp_quote')}
          onKeyUp={() => saveCursor('whatsapp_quote')}
          onMouseUp={() => saveCursor('whatsapp_quote')}
          onSelect={() => saveCursor('whatsapp_quote')}
          disabled={!canEdit}
          placeholder="Mensaje al enviar un presupuesto…"
        />
        <div className="aj-preview">
          <span className="aj-preview-lbl">Vista previa:</span>
          <span className="aj-preview-txt">{applyVars(tpl.whatsapp_quote, PREVIEW_LEAD)}</span>
        </div>
      </div>

      {/* WhatsApp por campaña (configuración del tenant / admin) */}
      {!userMode && (
        <div className="aj-card">
          <h3 className="aj-card-title"><span className="aj-icon aj-icon--wa"><IcoWA/></span>WhatsApp por campaña</h3>
          <p style={{ marginTop: -4, marginBottom: 12, color: '#64748b', fontSize: 13 }}>
            Mensajes específicos según la campaña del lead. Si un lead pertenece a una campaña con mensaje propio, se usará ese en lugar del general. Puedes elegir una campaña existente o escribir una nueva. Variables: <code>{'{{nombre}}'}</code> <code>{'{{Telefono}}'}</code> <code>{'{{poblacion}}'}</code> <code>{'{{fecha}}'}</code>.
          </p>
          <datalist id="aj-campaigns">
            {campaigns.map(c => <option key={c.campaign} value={c.campaign}>{`${c.campaign} (${c.count})`}</option>)}
          </datalist>

          {(tpl.whatsapp_campaigns || []).map((row, idx) => (
            <div key={idx} style={{ border: '1px solid #e2e8f0', borderRadius: 10, padding: 12, marginBottom: 12 }}>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 10 }}>
                <input
                  className="aj-input"
                  list="aj-campaigns"
                  value={row.campaign || ''}
                  onChange={e => updateCampaign(idx, 'campaign', e.target.value)}
                  disabled={!canEdit}
                  placeholder="Campaña (ID)…"
                  style={{ flex: 1 }}
                />
                {canEdit && (
                  <button
                    type="button"
                    onClick={() => removeCampaign(idx)}
                    title="Eliminar campaña"
                    style={{ background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca', borderRadius: 8, padding: '8px 12px', fontWeight: 700, cursor: 'pointer' }}
                  >✕</button>
                )}
              </div>

              <label className="aj-label">Sin presupuesto</label>
              <textarea
                className="aj-textarea"
                rows={3}
                value={row.whatsapp_no_quote || ''}
                onChange={e => updateCampaign(idx, 'whatsapp_no_quote', e.target.value)}
                disabled={!canEdit}
                placeholder="Mensaje de primer contacto para esta campaña…"
              />
              <div className="aj-preview">
                <span className="aj-preview-lbl">Vista previa:</span>
                <span className="aj-preview-txt">{applyVars(row.whatsapp_no_quote, PREVIEW_LEAD)}</span>
              </div>

              <label className="aj-label" style={{ display: 'block', marginTop: 10 }}>Con presupuesto</label>
              <textarea
                className="aj-textarea"
                rows={3}
                value={row.whatsapp_quote || ''}
                onChange={e => updateCampaign(idx, 'whatsapp_quote', e.target.value)}
                disabled={!canEdit}
                placeholder="Mensaje al enviar presupuesto para esta campaña…"
              />
              <div className="aj-preview">
                <span className="aj-preview-lbl">Vista previa:</span>
                <span className="aj-preview-txt">{applyVars(row.whatsapp_quote, PREVIEW_LEAD)}</span>
              </div>
            </div>
          ))}

          {(tpl.whatsapp_campaigns || []).length === 0 && (
            <p style={{ color: '#94a3b8', fontSize: 13, margin: '0 0 12px' }}>Aún no hay mensajes por campaña. El mensaje general se usará para todos los leads.</p>
          )}

          {canEdit && (
            <button
              type="button"
              onClick={addCampaign}
              style={{ background: '#f0fdf4', color: '#16a34a', border: '1px solid #bbf7d0', borderRadius: 8, padding: '10px 16px', fontWeight: 700, cursor: 'pointer' }}
            >+ Añadir campaña</button>
          )}
        </div>
      )}

      {/* Email */}
      <div className="aj-card">
        <h3 className="aj-card-title"><span className="aj-icon aj-icon--email"><IcoEmail/></span>Email</h3>
        <div className="aj-field">
          <label className="aj-label">Asunto</label>
          <input
            ref={fieldRefs.email_subject}
            className={`aj-input ${focused==='email_subject' ? 'aj-input--focused' : ''}`}
            value={tpl.email_subject || ''}
            onChange={e => set('email_subject', e.target.value)}
            onFocus={() => saveCursor('email_subject')}
            onKeyUp={() => saveCursor('email_subject')}
            onMouseUp={() => saveCursor('email_subject')}
            onSelect={() => saveCursor('email_subject')}
            disabled={!canEdit}
            placeholder="Asunto del email…"
          />
          <div className="aj-preview">
            <span className="aj-preview-lbl">Vista previa:</span>
            <span className="aj-preview-txt">{applyVars(tpl.email_subject, PREVIEW_LEAD)}</span>
          </div>
        </div>
        <div className="aj-field" style={{ marginTop: 12 }}>
          <label className="aj-label">Cuerpo</label>
          <textarea
            ref={fieldRefs.email_body}
            className={`aj-textarea ${focused==='email_body' ? 'aj-textarea--focused' : ''}`}
            rows={6}
            value={tpl.email_body || ''}
            onChange={e => set('email_body', e.target.value)}
            onFocus={() => saveCursor('email_body')}
            onKeyUp={() => saveCursor('email_body')}
            onMouseUp={() => saveCursor('email_body')}
            onSelect={() => saveCursor('email_body')}
            disabled={!canEdit}
            placeholder="Cuerpo del email…"
          />
          <div className="aj-preview aj-preview--pre">
            <span className="aj-preview-lbl">Vista previa:</span>
            <span className="aj-preview-txt">{applyVars(tpl.email_body, PREVIEW_LEAD)}</span>
          </div>
        </div>
      </div>

      {canEdit ? (
        <div className="aj-footer">
          <button className={`aj-save ${saved ? 'aj-save--ok' : ''}`} onClick={save} disabled={saving}>
            {saved ? '✓ Guardado' : saving ? 'Guardando…' : 'Guardar cambios'}
          </button>
        </div>
      ) : (
        <p className="aj-no-perm">Solo los administradores pueden editar estas plantillas.</p>
      )}
    </div>
  );
}

// ── FacebookTab ───────────────────────────────────────────────────────────────

function FacebookTab({ token }) {
  const [connections, setConnections] = useState([]);
  const [loadingC,    setLoadingC]    = useState(true);
  const [connecting,  setConnecting]  = useState(false);
  const [importing,   setImporting]   = useState(false);
  const [importResult,setImportResult]= useState(null);
  const [customRange, setCustomRange] = useState(false);
  const [importSince, setImportSince] = useState('');
  const [importUntil, setImportUntil] = useState('');
  const [logs,        setLogs]        = useState([]);
  const [successMsg,  setSuccessMsg]  = useState('');
  const [errorMsg,    setErrorMsg]    = useState('');

  // Selector de página/formulario tras OAuth
  const [selectKey,    setSelectKey]    = useState(null);
  const [selectorPages,setSelectorPages]= useState([]);
  const [selPage,      setSelPage]      = useState('');
  const [selForm,      setSelForm]      = useState('');
  const [loadingSel,   setLoadingSel]   = useState(false);
  const [savingSel,    setSavingSel]    = useState(false);

  // Formulario manual
  const [manualOpen,     setManualOpen]     = useState(false);
  const [manualPageId,   setManualPageId]   = useState('');
  const [manualPageName, setManualPageName] = useState('');
  const [manualFormId,   setManualFormId]   = useState('');
  const [manualFormName, setManualFormName] = useState('');
  const [savingManual,   setSavingManual]   = useState(false);

  // Listado de formularios de la cuenta (Graph en caliente, sin re-OAuth)
  const [availPages,   setAvailPages]   = useState(null); // null = no cargado aún
  const [loadingAvail, setLoadingAvail] = useState(false);
  const [togglingForm, setTogglingForm] = useState('');

  useEffect(() => {
    const count = sessionStorage.getItem('fb_just_connected');
    const err   = sessionStorage.getItem('fb_just_error');
    const key   = sessionStorage.getItem('fb_select_key');
    if (count) { setSuccessMsg(`Formulario conectado. Los leads llegarán automáticamente al CRM.`); sessionStorage.removeItem('fb_just_connected'); }
    if (err)   { setErrorMsg(decodeURIComponent(err)); sessionStorage.removeItem('fb_just_error'); }
    if (key) {
      sessionStorage.removeItem('fb_select_key');
      setSelectKey(key);
      setLoadingSel(true);
      apiGet(`/facebook/pending-pages?key=${key}`, token)
        .then(pages => { setSelectorPages(pages); if (pages.length) setSelPage(pages[0].id); })
        .catch(e => setErrorMsg(e.message))
        .finally(() => setLoadingSel(false));
    }
    loadConnections();
    loadLogs();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function loadConnections() {
    setLoadingC(true);
    try { setConnections(await apiGet('/facebook/connections', token)); }
    catch {}
    finally { setLoadingC(false); }
  }

  async function loadLogs() {
    try { setLogs(await apiGet('/facebook/import-logs', token)); }
    catch {}
  }

  async function connect() {
    setConnecting(true);
    try {
      const { url } = await apiGet('/facebook/auth-url', token);
      window.location.href = url;
    } catch (e) {
      setErrorMsg(e.message);
      setConnecting(false);
    }
  }

  async function deleteConn(id) {
    if (!window.confirm('¿Eliminar esta conexión? Dejarán de llegar leads de este formulario.')) return;
    try {
      await apiDelete(`/facebook/connections/${id}`, token);
      setConnections(p => p.filter(c => c.id !== id));
    } catch (e) { alert(e.message); }
  }

  async function deleteAllConns() {
    if (!window.confirm(`¿Desconectar todas las conexiones (${connections.length})? Dejarán de llegar leads de todos los formularios.`)) return;
    try {
      await apiDelete('/facebook/connections', token);
      setConnections([]);
      setSuccessMsg('Todas las conexiones eliminadas.');
    } catch (e) { alert(e.message); }
  }

  async function importNow() {
    setImporting(true);
    setImportResult(null);
    try {
      let url = '/facebook/import-leads';
      if (customRange && importSince) {
        const params = new URLSearchParams();
        params.set('since', importSince);
        if (importUntil) params.set('until', importUntil);
        url += '?' + params.toString();
      }
      const result = await apiGet(url, token);
      setImportResult(result);
      loadLogs();
    } catch (e) {
      setErrorMsg(e.message);
    } finally {
      setImporting(false);
    }
  }

  const fmtDate = d => _fmtDateUTC(d);

  const currentPage  = selectorPages.find(p => p.id === selPage);
  const availForms   = currentPage?.forms || [];
  const allNoForms   = selectorPages.length > 0 && selectorPages.every(p => (p.forms || []).length === 0);

  async function confirmConnection() {
    if (!selectKey || !selPage) return;
    setSavingSel(true);
    try {
      await apiPost('/facebook/confirm-connection', { key: selectKey, page_id: selPage, form_id: selForm || null }, token);
      setSelectKey(null);
      setSelectorPages([]);
      setSelPage('');
      setSelForm('');
      setSuccessMsg('Formulario conectado correctamente. Los leads llegarán automáticamente al CRM.');
      loadConnections();
    } catch (e) {
      setErrorMsg(e.message);
    } finally {
      setSavingSel(false);
    }
  }

  async function saveManualConnection() {
    if (!manualPageId.trim() || !manualFormId.trim()) return;
    setSavingManual(true);
    try {
      await apiPost('/facebook/manual-connection', {
        page_id:   manualPageId.trim(),
        form_id:   manualFormId.trim(),
        form_name: manualFormName.trim() || manualFormId.trim(),
        page_name: manualPageName.trim() || manualPageId.trim(),
      }, token);
      setManualPageId(''); setManualPageName(''); setManualFormId(''); setManualFormName('');
      setManualOpen(false);
      setSuccessMsg('Formulario añadido manualmente. Los leads se importarán en la próxima sincronización automática.');
      loadConnections();
    } catch (e) {
      if (e.message === 'no_page_token') {
        setErrorMsg('Para añadir este formulario necesitas conectar primero tu cuenta de Facebook (botón "Conectar con Facebook"). Esto guarda el acceso a la página. Luego vuelve aquí y añade el formulario manualmente.');
      } else {
        setErrorMsg(e.message);
      }
    } finally {
      setSavingManual(false);
    }
  }

  async function loadAvailableForms() {
    setLoadingAvail(true);
    setErrorMsg('');
    try {
      const r = await apiGet('/facebook/available-forms', token);
      if (r.error === 'no_pages') {
        setAvailPages([]);
        setErrorMsg('Aún no hay ninguna página de Facebook conectada. Pulsa "Conectar con Facebook" una vez para guardar el acceso y luego podrás listar los formularios aquí.');
      } else {
        setAvailPages(r.pages || []);
      }
    } catch (e) { setErrorMsg(e.message); }
    finally { setLoadingAvail(false); }
  }

  async function toggleForm(page, form) {
    setTogglingForm(form.id);
    try {
      if (form.connected && form.connection_id) {
        await apiDelete(`/facebook/connections/${form.connection_id}`, token);
      } else {
        await apiPost('/facebook/manual-connection', {
          page_id:   page.page_id,
          form_id:   form.id,
          form_name: form.name || form.id,
          page_name: page.page_name || page.page_id,
        }, token);
      }
      // Refresca el estado marcado del listado y la lista de conexiones
      await Promise.all([loadAvailableForms(), loadConnections()]);
    } catch (e) { setErrorMsg(e.message); }
    finally { setTogglingForm(''); }
  }

  return (
    <div className="aj-fb">
      {/* Modal selector página/formulario */}
      {selectKey && (
        <div className="aj-fb-selector-overlay">
          <div className="aj-fb-selector">
            <h3 className="aj-fb-selector-title">Selecciona el formulario a conectar</h3>
            {loadingSel ? (
              <p className="aj-fb-selector-loading">Cargando páginas de Facebook…</p>
            ) : selectorPages.length === 0 ? (
              <p className="aj-fb-selector-loading">No se encontraron páginas.</p>
            ) : allNoForms ? (
              <>
                <div className="aj-fb-selector-noforms">
                  <p>✅ <strong>Acceso a Facebook guardado correctamente.</strong></p>
                  <p>No se detectaron formularios de Lead Ads en tus páginas (es normal si los formularios fueron creados desde una cuenta publicitaria diferente).</p>
                  <p>Usa la sección <strong>"Añadir formulario manualmente"</strong> para conectar el formulario introduciendo su Page ID y Form ID.</p>
                </div>
                <div className="aj-fb-selector-actions">
                  <button className="aj-fb-btn" onClick={() => { setSelectKey(null); setSelectorPages([]); setSuccessMsg('Acceso a Facebook guardado. Ahora añade el formulario manualmente con su Page ID y Form ID.'); }}>
                    Entendido, añadiré el formulario manualmente
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="aj-fb-selector-field">
                  <label className="aj-fb-selector-label">Página de Facebook</label>
                  <select className="aj-fb-selector-sel" value={selPage} onChange={e => { setSelPage(e.target.value); setSelForm(''); }}>
                    {selectorPages.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
                  </select>
                </div>
                <div className="aj-fb-selector-field">
                  <label className="aj-fb-selector-label">Formulario</label>
                  {availForms.length === 0 ? (
                    <p className="aj-fb-selector-empty">Esta página no tiene formularios de Lead Ads detectados.</p>
                  ) : (
                    <select className="aj-fb-selector-sel" value={selForm} onChange={e => setSelForm(e.target.value)}>
                      <option value="">— Selecciona un formulario —</option>
                      {availForms.map(f => <option key={f.id} value={f.id}>{f.name}{f.status && f.status !== 'ACTIVE' ? ` (${f.status})` : ''}</option>)}
                    </select>
                  )}
                </div>
                <div className="aj-fb-selector-actions">
                  <button className="aj-fb-selector-cancel" onClick={() => { setSelectKey(null); setSelectorPages([]); }}>
                    Cancelar
                  </button>
                  <button
                    className="aj-fb-btn"
                    onClick={confirmConnection}
                    disabled={savingSel || !selPage || !selForm}
                  >
                    {savingSel ? 'Conectando…' : 'Conectar formulario'}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {successMsg && (
        <div className="aj-fb-banner aj-fb-banner--ok">
          <span>✅ {successMsg}</span>
          <button className="aj-fb-banner-close" onClick={() => setSuccessMsg('')}>✕</button>
        </div>
      )}
      {errorMsg && (
        <div className="aj-fb-banner aj-fb-banner--err">
          <span>❌ {errorMsg}</span>
          <button className="aj-fb-banner-close" onClick={() => setErrorMsg('')}>✕</button>
        </div>
      )}
      <div className="aj-card">
        <div className="aj-fb-connect-row">
          <div>
            <h3 className="aj-card-title"><span className="aj-icon aj-icon--fb"><IcoFacebook/></span>Conectar página de Facebook</h3>
            <p className="aj-fb-desc">Autoriza el acceso a tus páginas de Facebook para recibir los leads de tus formularios directamente en el CRM.</p>
          </div>
          {connections.length > 0 ? (
            <button className="aj-fb-btn-disconnect" onClick={deleteAllConns}>
              <IcoFacebook size={15}/>
              Desconectar Facebook
            </button>
          ) : (
            <button className="aj-fb-btn" onClick={connect} disabled={connecting}>
              <IcoFacebook size={15}/>
              {connecting ? 'Redirigiendo…' : 'Conectar con Facebook'}
            </button>
          )}
        </div>
      </div>
      {/* Formularios de tu cuenta (listado con casillas) */}
      <div className="aj-card">
        <div className="aj-fb-import-row">
          <div>
            <h3 className="aj-card-title" style={{ margin:0 }}>Formularios de tu cuenta</h3>
            <p className="aj-fb-desc" style={{ marginTop:4 }}>
              Lista todos los formularios de Lead Ads de tus páginas conectadas. Marca la casilla para recibir sus leads en el CRM, o desmárcala para dejar de recibirlos. No hace falta reconectar Facebook.
            </p>
          </div>
          <button className="aj-fb-import-btn" onClick={loadAvailableForms} disabled={loadingAvail}>
            {loadingAvail ? 'Cargando…' : (availPages === null ? 'Cargar formularios' : 'Actualizar lista')}
          </button>
        </div>

        {availPages !== null && !loadingAvail && (
          availPages.length === 0 ? (
            <p className="aj-fb-desc" style={{ marginTop:12 }}>No hay páginas conectadas todavía.</p>
          ) : (
            <div style={{ marginTop:14, display:'flex', flexDirection:'column', gap:16 }}>
              {availPages.map(page => (
                <div key={page.page_id}>
                  <div style={{ fontWeight:700, fontSize:14, marginBottom:6, color:'#1e293b' }}>
                    {page.page_name}
                  </div>
                  {page.error ? (
                    <p className="aj-fb-desc" style={{ color:'#b45309', margin:0 }}>
                      No se pudieron cargar los formularios de esta página ({page.error}). Puedes añadirlo manualmente más abajo.
                    </p>
                  ) : page.forms.length === 0 ? (
                    <p className="aj-fb-desc" style={{ margin:0 }}>Sin formularios de Lead Ads en esta página.</p>
                  ) : (
                    <div style={{ display:'flex', flexDirection:'column', gap:2 }}>
                      {page.forms.map(form => (
                        <label
                          key={form.id}
                          style={{ display:'flex', alignItems:'center', gap:10, padding:'8px 10px', borderRadius:8,
                                   background: form.connected ? '#ecfdf5' : '#f8fafc', border:'1px solid #e2e8f0', cursor:'pointer' }}
                        >
                          <input
                            type="checkbox"
                            checked={form.connected}
                            disabled={togglingForm === form.id}
                            onChange={() => toggleForm(page, form)}
                          />
                          <span style={{ flex:1, fontSize:14 }}>
                            {form.name}
                            {form.status && form.status !== 'ACTIVE' && (
                              <span style={{ color:'#94a3b8', fontSize:12, marginLeft:6 }}>({form.status})</span>
                            )}
                          </span>
                          {togglingForm === form.id && <span style={{ fontSize:12, color:'#64748b' }}>Guardando…</span>}
                          {form.connected && togglingForm !== form.id && <span style={{ fontSize:12, color:'#059669', fontWeight:600 }}>Conectado</span>}
                        </label>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )
        )}
      </div>

      {/* Añadir formulario manualmente */}
      <div className="aj-card">
        <div className="aj-fb-manual-header" onClick={() => setManualOpen(o => !o)}>
          <div>
            <h3 className="aj-card-title" style={{ margin:0 }}>Añadir formulario manualmente</h3>
            <p className="aj-fb-desc" style={{ marginTop:4 }}>
              Si tu formulario no aparece en el selector (fue creado desde otra cuenta publicitaria), puedes añadirlo con su ID directamente.
            </p>
          </div>
          <span className="aj-fb-manual-toggle">{manualOpen ? '▲' : '▼'}</span>
        </div>
        {manualOpen && (
          <div className="aj-fb-manual-form">
            <div className="aj-fb-manual-fields">
              <div className="aj-fb-manual-field">
                <label className="aj-fb-selector-label">Page ID <span style={{color:'#ef4444'}}>*</span></label>
                <input
                  className="aj-fb-manual-input"
                  placeholder="ej. 890123390839839"
                  value={manualPageId}
                  onChange={e => setManualPageId(e.target.value)}
                />
              </div>
              <div className="aj-fb-manual-field">
                <label className="aj-fb-selector-label">Nombre de la página (opcional)</label>
                <input
                  className="aj-fb-manual-input"
                  placeholder="ej. ARO Integral SL"
                  value={manualPageName}
                  onChange={e => setManualPageName(e.target.value)}
                />
              </div>
              <div className="aj-fb-manual-field">
                <label className="aj-fb-selector-label">Form ID <span style={{color:'#ef4444'}}>*</span></label>
                <input
                  className="aj-fb-manual-input"
                  placeholder="ej. 849640124762472"
                  value={manualFormId}
                  onChange={e => setManualFormId(e.target.value)}
                />
              </div>
              <div className="aj-fb-manual-field">
                <label className="aj-fb-selector-label">Nombre del formulario <span style={{color:'#ef4444'}}>*</span></label>
                <input
                  className="aj-fb-manual-input"
                  placeholder="ej. Formulario contacto verano 2024"
                  value={manualFormName}
                  onChange={e => setManualFormName(e.target.value)}
                />
              </div>
            </div>
            <div className="aj-fb-manual-actions">
              <button
                className="aj-fb-btn"
                onClick={saveManualConnection}
                disabled={savingManual || !manualPageId.trim() || !manualFormId.trim() || !manualFormName.trim()}
              >
                {savingManual ? 'Guardando…' : 'Guardar conexión manual'}
              </button>
            </div>
          </div>
        )}
      </div>

      {connections.length > 0 && (
        <div className="aj-card">
          <div className="aj-fb-import-row">
            <div>
              <h3 className="aj-card-title" style={{ margin:0 }}>Importación manual</h3>
              <p className="aj-fb-desc" style={{ marginTop:4 }}>
                {customRange
                  ? 'Selecciona el rango de fechas para importar leads.'
                  : 'Importa leads de las últimas 24h desde todos los formularios conectados. El sistema lo hace automáticamente cada 15 min.'}
              </p>
            </div>
            <button className="aj-fb-import-btn" onClick={importNow} disabled={importing || (customRange && !importSince)}>
              {importing ? 'Importando…' : 'Importar leads ahora'}
            </button>
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:12, marginTop:10, flexWrap:'wrap' }}>
            <label style={{ display:'flex', alignItems:'center', gap:6, cursor:'pointer', fontSize:14 }}>
              <input type="checkbox" checked={customRange} onChange={e => setCustomRange(e.target.checked)} />
              Personalizar fechas
            </label>
            {customRange && (
              <>
                <label style={{ fontSize:13 }}>
                  Desde: <input type="date" value={importSince} onChange={e => setImportSince(e.target.value)}
                    style={{ marginLeft:4, padding:'4px 8px', borderRadius:6, border:'1px solid #d0d5dd', fontSize:13 }} />
                </label>
                <label style={{ fontSize:13 }}>
                  Hasta: <input type="date" value={importUntil} onChange={e => setImportUntil(e.target.value)}
                    style={{ marginLeft:4, padding:'4px 8px', borderRadius:6, border:'1px solid #d0d5dd', fontSize:13 }} />
                </label>
              </>
            )}
          </div>
          {importResult && (
            <div>
              <div className="aj-fb-import-result">
                ✅ <strong>{importResult.imported}</strong> lead{importResult.imported !== 1 ? 's' : ''} importado{importResult.imported !== 1 ? 's' : ''}, <strong>{importResult.skipped}</strong> ignorado{importResult.skipped !== 1 ? 's' : ''} (ya existían)
              </div>
              {importResult.errors && importResult.errors.length > 0 && (
                <div className="aj-fb-import-errors">
                  {importResult.errors.map((e, i) => <div key={i}>⚠️ {e}</div>)}
                </div>
              )}
            </div>
          )}
        </div>
      )}
      {logs.length > 0 && (
        <div className="aj-card">
          <h3 className="aj-card-title" style={{ marginBottom: 12 }}>Historial de sincronizaciones</h3>
          <div className="aj-fb-logs">
            {logs.map(l => {
              const d = _parseUTC(l.ran_at) || new Date();
              const fecha = d.toLocaleDateString('es-ES', { timeZone: 'Europe/Madrid', day:'2-digit', month:'2-digit', year:'2-digit' });
              const hora  = d.toLocaleTimeString('es-ES', { timeZone: 'Europe/Madrid', hour:'2-digit', minute:'2-digit' });
              return (
                <div key={l.id} className="aj-fb-log-row">
                  <span className="aj-fb-log-time">{fecha} {hora}</span>
                  <span className={`aj-fb-log-src aj-fb-log-src--${l.source}`}>
                    {l.source === 'manual' ? 'Manual' : 'Auto'}
                  </span>
                  <span className="aj-fb-log-leads">
                    <strong className={l.imported > 0 ? 'aj-fb-log-new' : ''}>
                      +{l.imported}
                    </strong>
                    {' '}lead{l.imported !== 1 ? 's' : ''}
                  </span>
                  {l.skipped > 0 && (
                    <span className="aj-fb-log-skipped">{l.skipped} ignorado{l.skipped !== 1 ? 's' : ''}</span>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
      <div className="aj-card">
        <div style={{ marginBottom: connections.length ? 12 : 0 }}>
          <h3 className="aj-card-title" style={{ margin:0 }}>Conexiones activas</h3>
        </div>
        {loadingC ? (
          <div className="aj-fb-empty">Cargando…</div>
        ) : connections.length === 0 ? (
          <div className="aj-fb-empty">No hay ninguna conexión. Haz clic en "Conectar con Facebook" para empezar.</div>
        ) : (
          <div className="aj-fb-list">
            {connections.map(c => (
              <div key={c.id} className="aj-fb-row">
                <div className="aj-fb-row-icon"><IcoFacebook size={18}/></div>
                <div className="aj-fb-row-info">
                  <span className="aj-fb-page">{c.page_name || c.page_id}</span>
                  {c.form_name
                    ? <span className="aj-fb-form">Formulario: {c.form_name}</span>
                    : <span className="aj-fb-form aj-fb-form--all">Todos los formularios</span>
                  }
                  <span className="aj-fb-date">Conectado el {fmtDate(c.created_at)}</span>
                </div>
                <span className={`aj-fb-status ${c.active ? 'aj-fb-status--on' : 'aj-fb-status--off'}`}>
                  {c.active ? 'Activo' : 'Inactivo'}
                </span>
                <button className="aj-fb-del" onClick={() => deleteConn(c.id)} title="Eliminar conexión">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
                    <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6M10 11v6M14 11v6M9 6V4h6v2"/>
                  </svg>
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

// ── AsignacionTab ────────────────────────────────────────────────────────────

function AsignacionTab({ token }) {
  const { auth } = useContext(AuthContext);
  const isAdmin = ['admin', 'superadmin'].includes(auth.user?.role);

  const [enabled, setEnabled]     = useState(false);
  const [users, setUsers]         = useState([]);
  const [selected, setSelected]   = useState([]);
  const [loading, setLoading]     = useState(true);
  const [saving, setSaving]       = useState(false);
  const [saved, setSaved]         = useState(false);

  useEffect(() => {
    apiGet('/users/round-robin', token)
      .then(d => {
        setEnabled(d.enabled);
        setUsers(d.users || []);
        setSelected((d.users || []).filter(u => u.round_robin_active).map(u => u.id));
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [token]);

  function toggle(id) {
    setSelected(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  }

  function selectAll() {
    setSelected(users.map(u => u.id));
  }

  function selectNone() {
    setSelected([]);
  }

  async function save() {
    setSaving(true);
    try {
      await apiPut('/users/round-robin', { enabled, user_ids: enabled ? selected : [] }, token);
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (e) { alert(e.message); }
    finally { setSaving(false); }
  }

  if (loading) return <div className="aj-loading">Cargando configuración…</div>;

  const comerciales = users.filter(u => u.role === 'comercial');
  const empresas    = users.filter(u => u.role === 'empresa-cliente');

  return (
    <div className="aj-empresa">
      <div className="aj-card">
        <h3 className="aj-card-title">Asignación de leads</h3>
        <p className="aj-empresa-hint">
          Elige cómo se asignan los leads nuevos que entran al CRM (formularios web, Facebook, webhooks).
        </p>
        <div style={{ display:'flex', gap:12, marginTop:12 }}>
          <button
            className={`aj-assign-mode ${!enabled ? 'aj-assign-mode--active' : ''}`}
            onClick={() => setEnabled(false)}
            disabled={!isAdmin}
          >
            <strong>Manual</strong>
            <span>Los leads llegan sin asignar. El admin los reparte manualmente.</span>
          </button>
          <button
            className={`aj-assign-mode ${enabled ? 'aj-assign-mode--active' : ''}`}
            onClick={() => setEnabled(true)}
            disabled={!isAdmin}
          >
            <strong>Automático (Round-Robin)</strong>
            <span>Los leads se reparten equitativamente entre los seleccionados.</span>
          </button>
        </div>
      </div>

      {enabled && (
        <div className="aj-card">
          <h3 className="aj-card-title">Participantes en el reparto</h3>
          <p className="aj-empresa-hint">Selecciona los comerciales y/o empresas que recibirán leads automáticamente.</p>
          <div style={{ display:'flex', gap:8, marginBottom:12 }}>
            <button className="aj-assign-sel-btn" onClick={selectAll} disabled={!isAdmin}>Seleccionar todos</button>
            <button className="aj-assign-sel-btn" onClick={selectNone} disabled={!isAdmin}>Deseleccionar todos</button>
          </div>

          {comerciales.length > 0 && (
            <>
              <div className="aj-assign-group-title">Comerciales</div>
              <div className="aj-assign-list">
                {comerciales.map(u => (
                  <label key={u.id} className={`aj-assign-item ${selected.includes(u.id) ? 'aj-assign-item--on' : ''}`}>
                    <input type="checkbox" checked={selected.includes(u.id)} onChange={() => toggle(u.id)} disabled={!isAdmin} />
                    <span>{u.name}</span>
                  </label>
                ))}
              </div>
            </>
          )}

          {empresas.length > 0 && (
            <>
              <div className="aj-assign-group-title" style={{ marginTop:16 }}>Empresas</div>
              <div className="aj-assign-list">
                {empresas.map(u => (
                  <label key={u.id} className={`aj-assign-item ${selected.includes(u.id) ? 'aj-assign-item--on' : ''}`}>
                    <input type="checkbox" checked={selected.includes(u.id)} onChange={() => toggle(u.id)} disabled={!isAdmin} />
                    <span>{u.name}</span>
                  </label>
                ))}
              </div>
            </>
          )}

          {users.length === 0 && (
            <p className="aj-empresa-hint" style={{marginTop:8}}>No hay comerciales ni empresas activas en este tenant.</p>
          )}
        </div>
      )}

      {isAdmin && (
        <div className="aj-footer">
          <button className={`aj-save ${saved ? 'aj-save--ok' : ''}`} onClick={save} disabled={saving}>
            {saved ? '✓ Guardado' : saving ? 'Guardando…' : 'Guardar cambios'}
          </button>
        </div>
      )}
    </div>
  );
}

// ── PiePresupuestoTab ─────────────────────────────────────────────────────────

const PIE_DEFAULT_CONDICIONES = `Presupuesto PVP ${new Date().getFullYear()}. Incluye instalación y mano de obra. Válido 30 días desde la fecha de emisión. Documento orientativo; presupuesto definitivo confirmado por el departamento comercial.`;

const PIE_DEFAULT_PAGO = `• 100 € en concepto de reserva para visita técnica con el instalador
• 70% del total restante antes del inicio de la instalación
• 30% restante a la entrega del material e instalación completada`;

function PiePresupuestoTab({ token }) {
  const { auth, setAuth } = useContext(AuthContext);
  const isAdmin = ['admin', 'superadmin'].includes(auth.user?.role);

  const [condiciones, setCondiciones] = useState('');
  const [condicionesSin, setCondicionesSin] = useState('');
  const [formaPago, setFormaPago]     = useState('');
  const [cuentaNombre, setCuentaNombre] = useState('');
  const [cuentaIban, setCuentaIban]   = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving]   = useState(false);
  const [saved, setSaved]     = useState(false);

  useEffect(() => {
    apiGet('/settings', token)
      .then(d => {
        const qf = d.company_data?.quote_footer || {};
        setCondiciones(qf.condiciones ?? '');
        setCondicionesSin(qf.condiciones_sin_instalacion ?? '');
        setFormaPago(qf.forma_pago ?? '');
        setCuentaNombre(qf.cuenta_nombre ?? '');
        setCuentaIban(qf.cuenta_iban ?? '');
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [token]);

  async function save() {
    setSaving(true);
    try {
      const current = await apiGet('/settings', token);
      const company = current.company_data || {};
      company.quote_footer = {
        condiciones,
        condiciones_sin_instalacion: condicionesSin,
        forma_pago: formaPago,
        cuenta_nombre: cuentaNombre,
        cuenta_iban: cuentaIban,
      };
      await apiPut('/settings', { logo: current.logo || null, colors: current.colors || {}, company_data: company }, token);
      setAuth(prev => ({
        ...prev,
        tenant: { ...(prev.tenant || {}), company_data: company },
      }));
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (e) {
      alert(e.message);
    } finally {
      setSaving(false);
    }
  }

  if (loading) return <div className="aj-loading">Cargando configuración…</div>;

  return (
    <div className="aj-empresa">
      <div className="aj-card">
        <h3 className="aj-card-title">Condiciones — Con instalación</h3>
        <p className="aj-empresa-hint">Texto que aparece cuando el presupuesto incluye instalación y mano de obra.</p>
        <textarea
          className="aj-input"
          rows={4}
          value={condiciones}
          onChange={e => setCondiciones(e.target.value)}
          placeholder={PIE_DEFAULT_CONDICIONES}
          disabled={!isAdmin}
          style={{ resize: 'vertical', fontFamily: 'inherit', fontSize: 13, lineHeight: 1.5 }}
        />
      </div>

      <div className="aj-card">
        <h3 className="aj-card-title">Condiciones — Sin instalación</h3>
        <p className="aj-empresa-hint">Texto que aparece cuando el presupuesto NO incluye instalación (solo material).</p>
        <textarea
          className="aj-input"
          rows={4}
          value={condicionesSin}
          onChange={e => setCondicionesSin(e.target.value)}
          placeholder={`Presupuesto PVP ${new Date().getFullYear()}. No incluye mano de obra ni instalación. Válido 30 días desde la fecha de emisión. Documento orientativo; presupuesto definitivo confirmado por el departamento comercial.`}
          disabled={!isAdmin}
          style={{ resize: 'vertical', fontFamily: 'inherit', fontSize: 13, lineHeight: 1.5 }}
        />
      </div>

      <div className="aj-card">
        <h3 className="aj-card-title">Forma de pago</h3>
        <p className="aj-empresa-hint">Detalla los plazos y condiciones de pago. Cada línea se mostrará como un punto separado.</p>
        <textarea
          className="aj-input"
          rows={4}
          value={formaPago}
          onChange={e => setFormaPago(e.target.value)}
          placeholder={PIE_DEFAULT_PAGO}
          disabled={!isAdmin}
          style={{ resize: 'vertical', fontFamily: 'inherit', fontSize: 13, lineHeight: 1.5 }}
        />
      </div>

      <div className="aj-card">
        <h3 className="aj-card-title">Datos bancarios</h3>
        <p className="aj-empresa-hint">Número de cuenta y titular para las transferencias.</p>
        <div className="aj-empresa-grid">
          <div className="aj-field">
            <label className="aj-label">Titular de la cuenta</label>
            <input className="aj-input" value={cuentaNombre} onChange={e => setCuentaNombre(e.target.value)} placeholder="EMPRESA S.L." disabled={!isAdmin} />
          </div>
          <div className="aj-field">
            <label className="aj-label">IBAN</label>
            <input className="aj-input" value={cuentaIban} onChange={e => setCuentaIban(e.target.value)} placeholder="ES00 0000 0000 0000 0000 0000" disabled={!isAdmin} />
          </div>
        </div>
      </div>

      {isAdmin ? (
        <div className="aj-footer">
          <button className={`aj-save ${saved ? 'aj-save--ok' : ''}`} onClick={save} disabled={saving}>
            {saved ? '✓ Guardado' : saving ? 'Guardando…' : 'Guardar cambios'}
          </button>
        </div>
      ) : (
        <p className="aj-no-perm">Solo los administradores pueden editar esta configuración.</p>
      )}
    </div>
  );
}

// ── FinanciacionTab — descuento ficticio (siempre) + financiación (con módulo) ──

function FinanciacionTab({ token, hasFinModule }) {
  const { auth, setAuth } = useContext(AuthContext);
  const isAdmin = ['admin', 'superadmin'].includes(auth.user?.role);

  const [dtoFicticio, setDtoFicticio] = useState('');
  const [recargo, setRecargo] = useState('');
  const [meses, setMeses]     = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving]   = useState(false);
  const [saved, setSaved]     = useState(false);

  useEffect(() => {
    apiGet('/settings', token)
      .then(d => {
        const f = d.company_data?.financiacion || {};
        setDtoFicticio(f.dto_ficticio_pct ?? '');
        setRecargo(f.recargo_pct ?? '');
        setMeses(f.meses ?? '');
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [token]);

  async function save() {
    setSaving(true);
    try {
      const current = await apiGet('/settings', token);
      const company = current.company_data || {};
      const prevFin = company.financiacion || {};
      company.financiacion = {
        ...prevFin,
        dto_ficticio_pct: dtoFicticio === '' ? null : Number(dtoFicticio),
        ...(hasFinModule ? {
          recargo_pct: recargo === '' ? null : Number(recargo),
          meses:       meses === ''   ? null : Number(meses),
        } : {}),
      };
      await apiPut('/settings', { logo: current.logo || null, colors: current.colors || {}, company_data: company, round_robin_enabled: current.round_robin_enabled }, token);
      setAuth(prev => ({ ...prev, tenant: { ...(prev.tenant || {}), company_data: company } }));
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (e) {
      alert(e.message);
    } finally {
      setSaving(false);
    }
  }

  if (loading) return <div className="aj-loading">Cargando configuración…</div>;

  return (
    <div className="aj-empresa">
      <div className="aj-card">
        <h3 className="aj-card-title">Descuento ficticio (%)</h3>
        <p className="aj-empresa-hint">Descuento de marketing que aparecerá en los presupuestos (precio de tarifa tachado → precio real). No modifica el precio real, es solo visual. Déjalo vacío o en 0 para no mostrar ninguno.</p>
        <div className="aj-field" style={{ maxWidth: 200 }}>
          <input className="aj-input" type="number" min="0" max="100" step="1" value={dtoFicticio}
            onChange={e => setDtoFicticio(e.target.value)} placeholder="0" disabled={!isAdmin} />
        </div>
      </div>

      {hasFinModule ? (
        <div className="aj-card">
          <h3 className="aj-card-title">Financiación</h3>
          <p className="aj-empresa-hint">Recargo que se suma al precio para la modalidad financiada y número de cuotas. Precio financiado = precio al contado × (1 + recargo %).</p>
          <div className="aj-empresa-grid">
            <div className="aj-field">
              <label className="aj-label">Recargo de financiación (%)</label>
              <input className="aj-input" type="number" min="0" max="100" step="1" value={recargo}
                onChange={e => setRecargo(e.target.value)} placeholder="10" disabled={!isAdmin} />
            </div>
            <div className="aj-field">
              <label className="aj-label">Nº de meses / cuotas</label>
              <input className="aj-input" type="number" min="1" step="1" value={meses}
                onChange={e => setMeses(e.target.value)} placeholder="36" disabled={!isAdmin} />
            </div>
          </div>
        </div>
      ) : (
        <div className="aj-card">
          <p className="aj-empresa-hint">La modalidad de financiación no está activada para tu empresa. Contacta con tu administrador si quieres habilitarla.</p>
        </div>
      )}

      {isAdmin ? (
        <div className="aj-footer">
          <button className={`aj-save ${saved ? 'aj-save--ok' : ''}`} onClick={save} disabled={saving}>
            {saved ? '✓ Guardado' : saving ? 'Guardando…' : 'Guardar cambios'}
          </button>
        </div>
      ) : (
        <p className="aj-no-perm">Solo los administradores pueden editar esta configuración.</p>
      )}
    </div>
  );
}

// ── CalculadoraTab ────────────────────────────────────────────────────────────

const CALC_SUBTABS = [
  { key: 'lamas', label: 'Lamas' },
  { key: 'pzap',  label: 'PVC c/zapatilla' },
  { key: 'ptubo', label: 'PVC c/tubo' },
  { key: 'psin',  label: 'PVC s/zapatilla' },
  { key: 'alu',   label: 'Aluminio' },
];

function CalculadoraTab({ token }) {
  const [products, setProducts] = useState([]);
  const [selKey,   setSelKey]   = useState('');
  const [draft,    setDraft]    = useState(null);
  const [prodName, setProdName] = useState('');
  const [active,   setActive]   = useState(true);
  const [subTab,   setSubTab]   = useState('lamas');
  const [saving,   setSaving]   = useState(false);
  const [saved,    setSaved]    = useState(false);
  const [loading,  setLoading]  = useState(true);
  const [bulkOpen, setBulkOpen] = useState(false);
  const [bulkPct,  setBulkPct]  = useState('');
  const [bulkSign, setBulkSign] = useState('+'); // '+' o '-'
  const [bulkBusy, setBulkBusy] = useState(false);
  const [bulkResult, setBulkResult] = useState(null);
  const [bulkKeys, setBulkKeys] = useState([]); // product_keys seleccionados para el ajuste

  function reloadProducts() {
    return apiGet('/calculator/config', token).then(data => {
      setProducts(data);
      const cur = data.find(p => p.product_key === selKey) || data[0];
      if (cur) applyProduct(cur);
    });
  }

  useEffect(() => {
    apiGet('/calculator/config', token)
      .then(data => {
        setProducts(data);
        if (data.length > 0) applyProduct(data[0]);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [token]); // eslint-disable-line

  function applyProduct(p) {
    setSelKey(p.product_key);
    setProdName(p.product_name);
    setActive(p.active);
    setDraft(JSON.parse(JSON.stringify(p.config)));
    setSubTab('lamas');
    setSaved(false);
  }

  function handleSelectKey(key) {
    const p = products.find(x => x.product_key === key);
    if (p) applyProduct(p);
  }

  function setLamaField(i, field, val) {
    setDraft(d => {
      const nd = JSON.parse(JSON.stringify(d));
      nd.lamas[i][field] = field === 'ref' ? val : (parseFloat(val) || 0);
      return nd;
    });
  }

  function setTipoPrice(tipoKey, section, field, val) {
    setDraft(d => {
      const nd = JSON.parse(JSON.stringify(d));
      if (!nd.tipos[tipoKey][section]) nd.tipos[tipoKey][section] = {};
      nd.tipos[tipoKey][section][field] = parseFloat(val) || 0;
      return nd;
    });
  }

  async function save() {
    if (!selKey || !draft) return;
    setSaving(true);
    try {
      await apiPut(`/calculator/config/${selKey}`, { config: draft, product_name: prodName, active }, token);
      setProducts(p => p.map(x => x.product_key === selKey ? { ...x, product_name: prodName, active, config: draft } : x));
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (e) {
      alert(e.message);
    } finally {
      setSaving(false);
    }
  }

  if (loading) return <div className="aj-loading">Cargando configuración de la calculadora…</div>;
  if (!products.length) return <div className="aj-loading">No hay productos configurados.</div>;

  const tipoEntries = draft ? Object.entries(draft.tipos).sort((a, b) => a[1].h - b[1].h) : [];

  const PriceCell = ({ val, onChange }) => (
    <input type="number" step="0.01" min="0" className="aj-price-input"
      value={val ?? ''} onChange={e => onChange(e.target.value)} placeholder="—" />
  );

  async function applyBulk() {
    const pct = (bulkSign === '-' ? -1 : 1) * (parseFloat(bulkPct) || 0);
    if (!pct) { alert('Indica un porcentaje distinto de 0'); return; }
    if (!bulkKeys.length) { alert('Selecciona al menos un modelo'); return; }
    const all = bulkKeys.length === products.length;
    const scope = all ? `TODOS los precios de los ${products.length} productos` : `${bulkKeys.length} modelo(s) seleccionado(s)`;
    if (!window.confirm(`Vas a aplicar ${pct > 0 ? '+' : ''}${pct}% a ${scope}. ¿Confirmar?`)) return;
    setBulkBusy(true);
    setBulkResult(null);
    try {
      // Si están todos seleccionados, no mandamos product_keys (aplica a todos, como antes)
      const payload = all ? { pct } : { pct, product_keys: bulkKeys };
      const r = await apiPost('/calculator/bulk-adjust', payload, token);
      setBulkResult({ ok: true, ...r });
      await reloadProducts();
    } catch (e) {
      setBulkResult({ ok: false, error: e.message });
    } finally {
      setBulkBusy(false);
    }
  }

  function toggleBulkKey(key) {
    setBulkKeys(ks => ks.includes(key) ? ks.filter(k => k !== key) : [...ks, key]);
  }

  return (
    <div className="aj-calc">
      <div className="aj-card">
        <div className="aj-calc-header">
          <div className="aj-field" style={{ flex: 1, minWidth: 200, marginBottom: 0 }}>
            <label className="aj-label">Producto</label>
            <select className="aj-input" value={selKey} onChange={e => handleSelectKey(e.target.value)}>
              {products.map(p => (
                <option key={p.product_key} value={p.product_key}>{p.product_name}</option>
              ))}
            </select>
          </div>
          <div className="aj-calc-ctrl">
            <label className="aj-label">Estado</label>
            <button className={`aj-toggle ${active ? 'aj-toggle--on' : ''}`} onClick={() => { setActive(a => !a); setSaved(false); }}>
              {active ? '● Activo' : '○ Inactivo'}
            </button>
          </div>
          <div className="aj-calc-ctrl">
            <label className="aj-label">&nbsp;</label>
            <button className="aj-save" style={{ background: '#1f2937' }} onClick={() => { setBulkOpen(true); setBulkResult(null); setBulkPct(''); setBulkSign('+'); setBulkKeys(products.map(p => p.product_key)); }}>
              % Ajustar precios
            </button>
          </div>
          <div className="aj-calc-ctrl">
            <label className="aj-label">&nbsp;</label>
            <button className={`aj-save ${saved ? 'aj-save--ok' : ''}`} onClick={save} disabled={saving || !draft}>
              {saved ? '✓ Guardado' : saving ? 'Guardando…' : 'Guardar cambios'}
            </button>
          </div>
        </div>
      </div>

      {bulkOpen && (
        <div onClick={() => !bulkBusy && setBulkOpen(false)}
          style={{position:'fixed',inset:0,background:'rgba(0,0,0,.5)',zIndex:1700,display:'flex',alignItems:'center',justifyContent:'center',padding:20}}>
          <div onClick={e => e.stopPropagation()}
            style={{background:'#fff',borderRadius:14,width:'100%',maxWidth:480,boxShadow:'0 20px 60px rgba(0,0,0,.3)',overflow:'hidden'}}>
            <div style={{padding:'18px 24px',borderBottom:'1px solid #e5e7eb',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <h3 style={{margin:0,fontSize:16}}>Ajustar precios por modelo</h3>
              <button onClick={() => setBulkOpen(false)} disabled={bulkBusy}
                style={{background:'none',border:'none',cursor:'pointer',fontSize:22,color:'#888'}}>✕</button>
            </div>
            <div style={{padding:24}}>
              <p style={{fontSize:13,color:'#4b5563',marginBottom:14,lineHeight:1.5}}>
                Selecciona los modelos/colores y aplica el porcentaje a sus precios (lamas y postes — pzap, ptubo, psin, alu). Las alturas (h) y número de lamas (n) no se tocan.
              </p>

              {/* Selección de modelos/colores */}
              <div style={{marginBottom:16}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8}}>
                  <span style={{fontSize:12,fontWeight:700,color:'#374151'}}>Modelos a ajustar ({bulkKeys.length}/{products.length})</span>
                  <div style={{display:'flex',gap:6}}>
                    <button type="button" disabled={bulkBusy} onClick={() => setBulkKeys(products.map(p => p.product_key))}
                      style={{fontSize:12,padding:'4px 10px',background:'#eef2ff',color:'#4f46e5',border:'1px solid #c7d2fe',borderRadius:6,cursor:'pointer',fontWeight:600}}>Todos</button>
                    <button type="button" disabled={bulkBusy} onClick={() => setBulkKeys([])}
                      style={{fontSize:12,padding:'4px 10px',background:'#fff',color:'#64748b',border:'1px solid #d1d5db',borderRadius:6,cursor:'pointer',fontWeight:600}}>Ninguno</button>
                  </div>
                </div>
                <div style={{maxHeight:180,overflowY:'auto',border:'1px solid #e5e7eb',borderRadius:8}}>
                  {products.map(p => {
                    const on = bulkKeys.includes(p.product_key);
                    return (
                      <label key={p.product_key} style={{display:'flex',alignItems:'center',gap:10,padding:'9px 12px',borderBottom:'1px solid #f1f5f9',cursor:bulkBusy?'default':'pointer',fontSize:13,background:on?'#f8faff':'#fff'}}>
                        <input type="checkbox" checked={on} disabled={bulkBusy} onChange={() => toggleBulkKey(p.product_key)} />
                        <span style={{color:'#1e293b'}}>{p.product_name}</span>
                        {!p.active && <span style={{fontSize:11,color:'#94a3b8'}}>· inactivo</span>}
                      </label>
                    );
                  })}
                </div>
              </div>

              <div style={{display:'flex',gap:10,alignItems:'stretch',marginBottom:14}}>
                <div style={{display:'flex',border:'1px solid #d1d5db',borderRadius:8,overflow:'hidden'}}>
                  <button onClick={() => setBulkSign('+')} disabled={bulkBusy}
                    style={{padding:'10px 18px',background:bulkSign==='+'?'#16a34a':'#fff',color:bulkSign==='+'?'#fff':'#374151',border:'none',cursor:'pointer',fontSize:18,fontWeight:700}}>
                    +
                  </button>
                  <button onClick={() => setBulkSign('-')} disabled={bulkBusy}
                    style={{padding:'10px 18px',background:bulkSign==='-'?'#dc2626':'#fff',color:bulkSign==='-'?'#fff':'#374151',border:'none',cursor:'pointer',fontSize:18,fontWeight:700,borderLeft:'1px solid #d1d5db'}}>
                    −
                  </button>
                </div>
                <input type="number" min="0" max="500" step="0.1" value={bulkPct} disabled={bulkBusy}
                  onChange={e => setBulkPct(e.target.value)} placeholder="p.ej. 10"
                  style={{flex:1,padding:'10px 14px',border:'1px solid #d1d5db',borderRadius:8,fontSize:16,fontFamily:'inherit'}}/>
                <div style={{display:'flex',alignItems:'center',padding:'0 12px',fontSize:18,fontWeight:600,color:'#6b7280'}}>%</div>
              </div>
              {bulkPct && (
                <div style={{background:'#f3f4f6',padding:'10px 14px',borderRadius:8,fontSize:13,color:'#374151',marginBottom:6}}>
                  Ejemplo: un precio de <strong>100,00 €</strong> pasará a <strong>{(100 * (1 + ((bulkSign==='-'?-1:1)*(parseFloat(bulkPct)||0))/100)).toFixed(2)} €</strong>.
                </div>
              )}
              {bulkResult?.ok && (
                <div style={{background:'#dcfce7',border:'1px solid #bbf7d0',color:'#166534',padding:'10px 14px',borderRadius:8,fontSize:13,marginTop:10}}>
                  ✓ Aplicado <strong>{bulkResult.applied_pct > 0 ? '+' : ''}{bulkResult.applied_pct}%</strong> · {bulkResult.products_updated} producto(s), {bulkResult.prices_touched} precio(s) actualizado(s).
                </div>
              )}
              {bulkResult && !bulkResult.ok && (
                <div style={{background:'#fee2e2',border:'1px solid #fecaca',color:'#991b1b',padding:'10px 14px',borderRadius:8,fontSize:13,marginTop:10}}>
                  ✕ {bulkResult.error}
                </div>
              )}
            </div>
            <div style={{padding:'14px 24px',borderTop:'1px solid #e5e7eb',display:'flex',gap:8,justifyContent:'flex-end',background:'#f9fafb'}}>
              <button onClick={() => setBulkOpen(false)} disabled={bulkBusy}
                style={{padding:'8px 14px',background:'#fff',border:'1px solid #d1d5db',borderRadius:6,cursor:'pointer',fontSize:13}}>
                {bulkResult?.ok ? 'Cerrar' : 'Cancelar'}
              </button>
              <button onClick={applyBulk} disabled={bulkBusy || !bulkPct || !parseFloat(bulkPct) || !bulkKeys.length}
                style={{padding:'8px 16px',background:bulkSign==='-'?'#dc2626':'#16a34a',color:'#fff',border:'none',borderRadius:6,cursor:'pointer',fontSize:13,fontWeight:600,opacity:(bulkBusy||!bulkPct||!parseFloat(bulkPct)||!bulkKeys.length)?.5:1}}>
                {bulkBusy ? 'Aplicando…' : `Aplicar ${bulkSign}${bulkPct||0}%`}
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="aj-calc-subtabs">
        {CALC_SUBTABS.map(s => (
          <button key={s.key} className={`aj-calc-stab ${subTab === s.key ? 'aj-calc-stab--on' : ''}`}
            onClick={() => setSubTab(s.key)}>
            {s.label}
          </button>
        ))}
      </div>

      {draft && (
        <div className="aj-card aj-calc-table-card">
          {subTab === 'lamas' && (
            <>
              <h3 className="aj-card-title">Lamas — precio y separación</h3>
              <div className="aj-ptable-wrap">
                <table className="aj-ptable">
                  <thead><tr><th>Referencia</th><th>Separación (m)</th><th>Precio (€/ud)</th></tr></thead>
                  <tbody>
                    {draft.lamas.map((l, i) => (
                      <tr key={i}>
                        <td className="aj-ptable-ref">{l.ref}</td>
                        <td><PriceCell val={l.sep}   onChange={v => setLamaField(i, 'sep',   v)} /></td>
                        <td><PriceCell val={l.price} onChange={v => setLamaField(i, 'price', v)} /></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
          {subTab === 'pzap' && (
            <>
              <h3 className="aj-card-title">Postes PVC con zapatilla</h3>
              <div className="aj-ptable-wrap">
                <table className="aj-ptable">
                  <thead><tr><th>Tipo</th><th>Altura</th><th>Final (€)</th><th>Intermedio (€)</th><th>Esquinero (€)</th></tr></thead>
                  <tbody>
                    {tipoEntries.map(([k, v]) => (
                      <tr key={k}>
                        <td className="aj-ptable-ref">{k}</td>
                        <td className="aj-ptable-h">{v.h} cm</td>
                        {['f','i','e'].map(fld => (
                          <td key={fld}><PriceCell val={v.pzap?.[fld]} onChange={val => setTipoPrice(k,'pzap',fld,val)}/></td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
          {subTab === 'ptubo' && (
            <>
              <h3 className="aj-card-title">Postes PVC con tubo</h3>
              <div className="aj-ptable-wrap">
                <table className="aj-ptable">
                  <thead><tr><th>Tipo</th><th>Altura</th><th>Final (€)</th><th>Intermedio (€)</th><th>Esquinero (€)</th></tr></thead>
                  <tbody>
                    {tipoEntries.map(([k, v]) => (
                      <tr key={k}>
                        <td className="aj-ptable-ref">{k}</td>
                        <td className="aj-ptable-h">{v.h} cm</td>
                        {['f','i','e'].map(fld => (
                          <td key={fld}><PriceCell val={v.ptubo?.[fld]} onChange={val => setTipoPrice(k,'ptubo',fld,val)}/></td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
          {subTab === 'psin' && (
            <>
              <h3 className="aj-card-title">Postes PVC sin zapatilla</h3>
              <div className="aj-ptable-wrap">
                <table className="aj-ptable">
                  <thead><tr><th>Tipo</th><th>Altura</th><th>Final (€)</th><th>Intermedio (€)</th><th>Esquinero (€)</th></tr></thead>
                  <tbody>
                    {tipoEntries.map(([k, v]) => (
                      <tr key={k}>
                        <td className="aj-ptable-ref">{k}</td>
                        <td className="aj-ptable-h">{v.h} cm</td>
                        {['f','i','e'].map(fld => (
                          <td key={fld}><PriceCell val={v.psin?.[fld]} onChange={val => setTipoPrice(k,'psin',fld,val)}/></td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
          {subTab === 'alu' && (
            <>
              <h3 className="aj-card-title">Postes Aluminio</h3>
              <div className="aj-ptable-wrap">
                <table className="aj-ptable">
                  <thead><tr><th>Tipo</th><th>Altura</th><th>Final Pared (€)</th><th>Final Doble (€)</th><th>Intermedio (€)</th><th>Esquinero (€)</th></tr></thead>
                  <tbody>
                    {tipoEntries.map(([k, v]) => (
                      <tr key={k}>
                        <td className="aj-ptable-ref">{k}</td>
                        <td className="aj-ptable-h">{v.h} cm</td>
                        {['fp','fd','i','e'].map(fld => (
                          <td key={fld}><PriceCell val={v.alu?.[fld]} onChange={val => setTipoPrice(k,'alu',fld,val)}/></td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

// ── PerfilTab — editar perfil propio (todos los roles) ────────────────────────
function PerfilTab() {
  const { auth, setAuth } = useContext(AuthContext);
  const token = auth.token;

  const [form, setForm] = useState({
    name:     auth.user?.name  || '',
    phone:    auth.user?.phone || '',
    password:  '',
    password2: '',
  });
  const [saving, setSaving] = useState(false);
  const [saved,  setSaved]  = useState(false);

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  async function save() {
    if (form.password && form.password !== form.password2) {
      alert('Las contraseñas no coinciden'); return;
    }
    setSaving(true);
    try {
      const body = { name: form.name, phone: form.phone };
      if (form.password) body.password = form.password;
      await apiPut('/users/me', body, token);
      setAuth(prev => ({
        ...prev,
        user: { ...prev.user, name: form.name, phone: form.phone },
      }));
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (e) {
      alert(e.message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="aj-empresa">
      <div className="aj-card">
        <h3 className="aj-card-title">Mi perfil</h3>
        <div className="aj-empresa-grid">
          <div className="aj-field">
            <label className="aj-label">Nombre completo</label>
            <input className="aj-input" value={form.name} onChange={e => set('name', e.target.value)} />
          </div>
          <div className="aj-field">
            <label className="aj-label">Email</label>
            <input className="aj-input" value={auth.user?.email || ''} disabled style={{ opacity: .6 }} />
          </div>
          <div className="aj-field">
            <label className="aj-label">Teléfono</label>
            <input className="aj-input" value={form.phone} onChange={e => set('phone', e.target.value)} placeholder="6XX XXX XXX" />
          </div>
        </div>
      </div>

      <div className="aj-card">
        <h3 className="aj-card-title">Cambiar contraseña</h3>
        <div className="aj-empresa-grid">
          <div className="aj-field">
            <label className="aj-label">Nueva contraseña</label>
            <input className="aj-input" type="password" value={form.password} onChange={e => set('password', e.target.value)} placeholder="••••••••" />
          </div>
          <div className="aj-field">
            <label className="aj-label">Confirmar contraseña</label>
            <input className="aj-input" type="password" value={form.password2} onChange={e => set('password2', e.target.value)} placeholder="••••••••" />
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', gap: '.75rem', alignItems: 'center' }}>
        <button className="aj-save-btn" onClick={save} disabled={saving}>
          {saving ? 'Guardando…' : 'Guardar cambios'}
        </button>
        {saved && <span style={{ color: '#16a34a', fontSize: '.85rem', fontWeight: 600 }}>✓ Guardado</span>}
      </div>
    </div>
  );
}

// ── MiEmpresaTab — branding del sub_tenant (solo empresa-cliente) ─────────────
function MiEmpresaTab() {
  const { auth, setAuth } = useContext(AuthContext);
  const token = auth.token;

  const [logo,    setLogo]    = useState('');
  const [colors,  setColors]  = useState({ brand: '#E84300', brandLight: '#FFF0EB' });
  const [company, setCompany] = useState({ nombre: '', nif: '', direccion: '', cp: '', ciudad: '', telefono: '', email: '', web: '' });
  const [loading, setLoading] = useState(true);
  const [saving,  setSaving]  = useState(false);
  const [saved,   setSaved]   = useState(false);

  useEffect(() => {
    apiGet('/sub-tenants/me', token)
      .then(d => {
        if (d.logo)         setLogo(d.logo);
        if (d.colors && Object.keys(d.colors).length) setColors(c => ({ ...c, ...d.colors }));
        if (d.company_data && Object.keys(d.company_data).length) setCompany(d.company_data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [token]);

  function handleLogoFile(e) {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 500 * 1024) { alert('Imagen de menos de 500 KB'); return; }
    const reader = new FileReader();
    reader.onload = evt => setLogo(evt.target.result);
    reader.readAsDataURL(file);
  }

  async function save() {
    setSaving(true);
    try {
      await apiPut('/sub-tenants/me', { logo: logo || null, colors, company_data: company }, token);
      // Refrescar auth.sub_tenant para que el sidebar/PDFs vean el logo/colores nuevos al instante
      setAuth(prev => ({
        ...(prev || {}),
        sub_tenant: { ...(prev?.sub_tenant || {}), logo: logo || null, colors, company_data: company },
      }));
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (e) {
      alert(e.message);
    } finally {
      setSaving(false);
    }
  }

  const set = (k, v) => setCompany(p => ({ ...p, [k]: v }));

  if (loading) return <div className="aj-loading">Cargando…</div>;

  return (
    <div className="aj-empresa">
      <div className="aj-card">
        <h3 className="aj-card-title">Logotipo de mi empresa</h3>
        <div className="aj-logo-row">
          <div className="aj-logo-preview">
            {logo ? <img src={logo} alt="Logo" /> : <span style={{ color: '#ccc', fontSize: '.8rem' }}>Sin logo</span>}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '.5rem' }}>
            <label className="aj-upload-btn">
              Subir imagen
              <input type="file" accept="image/*" style={{ display: 'none' }} onChange={handleLogoFile} />
            </label>
            {logo && <button className="aj-logo-del" onClick={() => setLogo('')}>Eliminar</button>}
          </div>
        </div>
      </div>

      <div className="aj-card">
        <h3 className="aj-card-title">Colores de mi empresa</h3>
        <div className="aj-color-list">
          {[
            { key: 'brand',      label: 'Color principal',      fallback: '#E84300' },
            { key: 'brandLight', label: 'Color de fondo claro', fallback: '#FFF0EB' },
          ].map(({ key, label, fallback }) => (
            <div key={key} className="aj-color-row">
              <input type="color" className="aj-color-input"
                value={colors[key] || fallback}
                onChange={e => setColors(c => ({ ...c, [key]: e.target.value }))} />
              <span>{label}</span>
              <code style={{ marginLeft: 'auto', fontSize: '.78rem', color: '#888' }}>{colors[key] || fallback}</code>
            </div>
          ))}
        </div>
      </div>

      <div className="aj-card">
        <h3 className="aj-card-title">Datos de empresa (para presupuestos)</h3>
        <div className="aj-empresa-grid">
          <div className="aj-field"><label className="aj-label">Nombre empresa</label><input className="aj-input" value={company.nombre||''} onChange={e => set('nombre', e.target.value)} /></div>
          <div className="aj-field"><label className="aj-label">NIF / CIF</label><input className="aj-input" value={company.nif||''} onChange={e => set('nif', e.target.value)} /></div>
          <div className="aj-field aj-field--full"><label className="aj-label">Dirección</label><input className="aj-input" value={company.direccion||''} onChange={e => set('direccion', e.target.value)} /></div>
          <div className="aj-field"><label className="aj-label">Código postal</label><input className="aj-input" value={company.cp||''} onChange={e => set('cp', e.target.value)} /></div>
          <div className="aj-field"><label className="aj-label">Ciudad</label><input className="aj-input" value={company.ciudad||''} onChange={e => set('ciudad', e.target.value)} /></div>
          <div className="aj-field"><label className="aj-label">Teléfono</label><input className="aj-input" value={company.telefono||''} onChange={e => set('telefono', e.target.value)} /></div>
          <div className="aj-field"><label className="aj-label">Email</label><input className="aj-input" value={company.email||''} onChange={e => set('email', e.target.value)} /></div>
          <div className="aj-field aj-field--full"><label className="aj-label">Web</label><input className="aj-input" value={company.web||''} onChange={e => set('web', e.target.value)} /></div>
        </div>
      </div>

      <div style={{ display: 'flex', gap: '.75rem', alignItems: 'center' }}>
        <button className="aj-save-btn" onClick={save} disabled={saving}>
          {saving ? 'Guardando…' : 'Guardar cambios'}
        </button>
        {saved && <span style={{ color: '#16a34a', fontSize: '.85rem', fontWeight: 600 }}>✓ Guardado</span>}
      </div>
    </div>
  );
}

// ── MargenesTab ───────────────────────────────────────────────────────────────

function MargenesTab({ token, role }) {
  const isAdmin   = ['admin', 'superadmin'].includes(role);
  const isEmpresa = role === 'empresa-cliente';

  // % propio (margen para admin/empresa)
  const [myPct,    setMyPct]    = useState('');
  const [loading,  setLoading]  = useState(true);
  const [saving,   setSaving]   = useState(false);
  const [saved,    setSaved]    = useState(false);

  // comerciales (solo admin)
  const [comerciales, setComerciales] = useState([]);
  const [commEdits,   setCommEdits]   = useState({}); // { userId: pctString }
  const [savingComm,  setSavingComm]  = useState(null); // userId en curso
  const [savedComm,   setSavedComm]   = useState(null); // userId guardado

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const rates = await apiGet('/users/me/rates', token);
        setMyPct(rates.margin_pct != null ? String(rates.margin_pct) : '');
        if (isAdmin) {
          const users = await apiGet('/users', token);
          const coms  = users.filter(u => u.role === 'comercial' && u.active);
          setComerciales(coms);
          const edits = {};
          coms.forEach(u => { edits[u.id] = u.commission_pct != null ? String(u.commission_pct) : ''; });
          setCommEdits(edits);
        }
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    fetchAll();
  }, [token, isAdmin]);

  async function saveMyMargin() {
    setSaving(true);
    try {
      await apiPut('/users/me/rates', { margin_pct: myPct !== '' ? parseFloat(myPct) : null }, token);
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (e) { alert(e.message); }
    finally { setSaving(false); }
  }

  async function saveCommission(userId) {
    setSavingComm(userId);
    try {
      const pct = commEdits[userId] !== '' ? parseFloat(commEdits[userId]) : null;
      await apiPut(`/users/${userId}`, {
        ...comerciales.find(u => u.id === userId),
        commission_pct: pct,
      }, token);
      setSavedComm(userId);
      setTimeout(() => setSavedComm(null), 2500);
    } catch (e) { alert(e.message); }
    finally { setSavingComm(null); }
  }

  if (loading) return <div className="aj-loading">Cargando…</div>;

  return (
    <div className="aj-empresa">

      {/* ── Margen de beneficio propio ── */}
      <div className="aj-card">
        <h3 className="aj-card-title">
          {isEmpresa ? 'Mi margen de beneficio' : 'Margen de beneficio'}
        </h3>
        <p className="aj-empresa-hint">
          {isEmpresa
            ? 'Este porcentaje representa tu margen de beneficio. Aparecerá en la calculadora para ayudarte a calcular el precio final.'
            : 'Define el margen de beneficio de tu empresa. Aparecerá en la calculadora como referencia de rentabilidad.'}
        </p>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 8 }}>
          <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
            <input
              className="aj-input"
              type="number"
              min="0" max="100" step="0.1"
              value={myPct}
              onChange={e => setMyPct(e.target.value)}
              placeholder="0"
              style={{ width: 110, paddingRight: 28 }}
            />
            <span style={{ position:'absolute', right:10, fontSize:14, color:'#94a3b8', pointerEvents:'none' }}>%</span>
          </div>
          <button className="aj-save-btn" onClick={saveMyMargin} disabled={saving} style={{ margin:0 }}>
            {saving ? 'Guardando…' : 'Guardar'}
          </button>
          {saved && <span style={{ color:'#16a34a', fontSize:'.85rem', fontWeight:600 }}>✓ Guardado</span>}
        </div>
      </div>

      {/* ── Comisiones de comerciales (solo admin) ── */}
      {isAdmin && (
        <div className="aj-card">
          <h3 className="aj-card-title">Comisiones de comerciales</h3>
          <p className="aj-empresa-hint">
            Establece el % de comisión de cada comercial activo. Lo verán reflejado en su calculadora.
          </p>
          {comerciales.length === 0 ? (
            <p style={{ fontSize:13, color:'#94a3b8', marginTop:8 }}>No hay comerciales activos.</p>
          ) : (
            <table style={{ width:'100%', borderCollapse:'collapse', marginTop:12 }}>
              <thead>
                <tr style={{ fontSize:11, fontWeight:700, color:'#94a3b8', textTransform:'uppercase', letterSpacing:'.08em', borderBottom:'1px solid var(--border)' }}>
                  <th style={{ textAlign:'left', padding:'6px 8px' }}>Comercial</th>
                  <th style={{ textAlign:'left', padding:'6px 8px' }}>Email</th>
                  <th style={{ textAlign:'left', padding:'6px 8px', width:140 }}>% Comisión</th>
                  <th style={{ width:100 }}></th>
                </tr>
              </thead>
              <tbody>
                {comerciales.map(u => (
                  <tr key={u.id} style={{ borderBottom:'1px solid var(--border)' }}>
                    <td style={{ padding:'8px 8px', fontSize:13, fontWeight:600 }}>{u.name}</td>
                    <td style={{ padding:'8px 8px', fontSize:12, color:'#64748b' }}>{u.email}</td>
                    <td style={{ padding:'8px 8px' }}>
                      <div style={{ position:'relative', display:'inline-flex', alignItems:'center' }}>
                        <input
                          className="aj-input"
                          type="number"
                          min="0" max="100" step="0.1"
                          value={commEdits[u.id] ?? ''}
                          onChange={e => setCommEdits(p => ({ ...p, [u.id]: e.target.value }))}
                          placeholder="0"
                          style={{ width:90, paddingRight:24, margin:0 }}
                        />
                        <span style={{ position:'absolute', right:8, fontSize:13, color:'#94a3b8', pointerEvents:'none' }}>%</span>
                      </div>
                    </td>
                    <td style={{ padding:'8px 8px' }}>
                      <div style={{ display:'flex', gap:6, alignItems:'center' }}>
                        <button
                          onClick={() => saveCommission(u.id)}
                          disabled={savingComm === u.id}
                          style={{ background:'var(--primary)', color:'#fff', border:'none', borderRadius:6, padding:'5px 12px', fontSize:12, fontWeight:600, cursor:'pointer' }}
                        >
                          {savingComm === u.id ? '…' : 'Guardar'}
                        </button>
                        {savedComm === u.id && <span style={{ color:'#16a34a', fontSize:11, fontWeight:600 }}>✓</span>}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}

// ── AjustesPage ───────────────────────────────────────────────────────────────

export default function AjustesPage() {
  const { auth } = useContext(AuthContext);
  const token   = auth.token;
  const role    = auth.user?.role;
  const isAdmin = ['admin', 'superadmin'].includes(role);
  const isEmpresa = role === 'empresa-cliente';
  const modules = auth.modules || [];
  const isSuperadmin = role === 'superadmin';
  const hasModule = m => isSuperadmin || modules.includes(m);
  const hasCalc = (isAdmin || isEmpresa) && hasModule('calculadora');
  const hasAutomatizacion = isAdmin && hasModule('automatizacion');
  const hasCrm = isAdmin && hasModule('crm');
  const hasMargins = (isAdmin || isEmpresa) && hasModule('calculadora');

  const NAV = [
    { key: 'perfil',      label: 'Mi perfil',              icon: <IcoUser size={15}/> },
    ...(isEmpresa ? [{ key: 'miempresa', label: 'Mi empresa',    icon: <IcoShop size={15}/> }] : []),
    ...(!isAdmin  ? [{ key: 'mensajes-personal', label: 'Mensajes',            icon: <IcoChat size={15}/> }] : []),
    ...(isAdmin   ? [{ key: 'empresa',           label: 'Conf. empresa',        icon: <IcoBuilding size={15}/> }] : []),
    ...(isAdmin   ? [{ key: 'mensajes',          label: 'Mensajes de contacto', icon: <IcoChat size={15}/> }] : []),
    ...(hasAutomatizacion ? [{ key: 'facebook',  label: 'Facebook Lead Ads',    icon: <IcoFacebook size={15}/> }] : []),
    ...(hasCrm    ? [{ key: 'asignacion',         label: 'Asignación de leads',  icon: <IcoReparto size={15}/> }] : []),
    ...(hasCalc   ? [{ key: 'pie-presupuesto',   label: 'Pie de presupuesto',   icon: <IcoDoc size={15}/> }] : []),
    ...(hasCalc   ? [{ key: 'financiacion',      label: 'Financiación y dtos.', icon: <IcoCalc size={15}/> }] : []),
    ...(hasCalc   ? [{ key: 'calculadora',       label: 'Precios Calculadora',  icon: <IcoCalc size={15}/> }] : []),
    ...(hasMargins ? [{ key: 'margenes', label: 'Márgenes y comisiones', icon: <IcoCalc size={15}/> }] : []),
  ];

  const [panel, setPanel] = useState('perfil');

  return (
    <div className="aj-page">

      {/* Sidebar de navegación */}
      <aside className="aj-sidenav">
        <div className="aj-sidenav-title">Ajustes</div>
        {NAV.map(item => (
          <button
            key={item.key}
            className={`aj-navitem ${panel === item.key ? 'aj-navitem--on' : ''}`}
            onClick={() => setPanel(item.key)}
          >
            <span className="aj-navitem-ico">{item.icon}</span>
            <span className="aj-navitem-lbl">{item.label}</span>
          </button>
        ))}
      </aside>

      {/* Contenido del panel activo */}
      <div className="aj-content">
        {panel === 'perfil'      && <PerfilTab />}
        {panel === 'miempresa'   && isEmpresa && <MiEmpresaTab />}
        {panel === 'empresa'     && isAdmin && <EmpresaTab />}
        {panel === 'mensajes-personal' && !isAdmin && <MensajesTab token={token} isAdmin={false} userMode={true} />}
        {panel === 'mensajes'    && isAdmin && <MensajesTab token={token} isAdmin={isAdmin} />}
        {panel === 'facebook'    && hasAutomatizacion && <FacebookTab token={token} />}
        {panel === 'asignacion' && hasCrm && <AsignacionTab token={token} />}
        {panel === 'pie-presupuesto' && hasCalc && <PiePresupuestoTab token={token} />}
        {panel === 'financiacion' && hasCalc && <FinanciacionTab token={token} hasFinModule={hasModule('financiacion')} />}
        {panel === 'calculadora' && hasCalc && <CalculadoraTab token={token} />}
        {panel === 'margenes'    && hasMargins && <MargenesTab token={token} role={role} />}
      </div>

    </div>
  );
}
